import React, { useState, useEffect } from "react";
import StarColorList from "./StarColorsList";
import Popover from "@material-ui/core/Popover";

export default function StarColorsListDropdown({
  onChange,
  value,
  colors,
  colorYellow,
  clearFocusedCell,
  starAnchorEl, 
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClose = () => {
    setAnchorEl(null);
    clearFocusedCell();
  };
  useEffect(() => {
      setAnchorEl(starAnchorEl);
  },[]);

  const handleChange = (e) => {
    setAnchorEl(null);
    onChange(e);
  };
  return (
    <>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <StarColorList 
          colors={colors} 
          colorYellow = {colorYellow} 
          value={value} 
          onChange={handleChange}  
          handleClose={handleClose}/>
      </Popover>
    </>
  );
}
